// extracted by mini-css-extract-plugin
export default {"drop":"DocumentDragDrop_drop__FsNIo","emptySelect":"DocumentDragDrop_emptySelect__Z7SfC","plusIcon":"DocumentDragDrop_plusIcon__3TcVH","openFile":"DocumentDragDrop_openFile__55zWY"};